import { render, staticRenderFns } from "./MSTeamsAuth.vue?vue&type=template&id=0cd1fb7e&"
import script from "./MSTeamsAuth.vue?vue&type=script&lang=js&"
export * from "./MSTeamsAuth.vue?vue&type=script&lang=js&"
import style0 from "./MSTeamsAuth.vue?vue&type=style&index=0&id=0cd1fb7e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports